import axios from "axios";

const client = axios.create({
  baseURL: process.env.VUE_APP_GENERATOR_URL,
  timeout: 15000,
});

export async function pingGenerator(): Promise<void> {
  try {
    await client.get("/ping");
  } catch {
    // warm-up silencioso — cualquier respuesta (incluso 404) despierta la función
  }
}

export interface Trick {
  name: string;
  family: string;
  levelName: string;
  code: string;
  cone: number;
  foot: string;
  side: string;
  entry: string;
  version: string;
  method: string;
}

export interface FilterParams {
  userId: string;
  number: number;
  families?: string[];
  levels?: string[];
}

export async function getFilteredTricks(params: FilterParams): Promise<Trick[]> {
  let path = `/tricks/filter?number=${params.number}`;
  if (params.families?.length) path += `&families=${params.families.join(",")}`;
  if (params.levels?.length) path += `&levels=${params.levels.join(",")}`;

  const response = await client.post(path, { userId: params.userId });
  return response.data.tricks || [];
}

export async function getRandomTricks(userId: string, count: number): Promise<Trick[]> {
  const response = await client.post(`/tricks/random/${count}`, { userId });
  return response.data.tricks;
}

export async function addToBlacklist(userId: string, tricks: Trick[]): Promise<void> {
  await client.post("/blacklist", { userId, tricks });
}

export async function removeFromBlacklist(userId: string, trickCode: string): Promise<void> {
  await client.post("/blacklist/remove", { userId, trickCode });
}
